import { ResponsiveBar } from "@nivo/bar";

const DiffrentChart = ({ data, keys }) => {
  return (
    <ResponsiveBar
      data={data}
      keys={keys}
      indexBy="country"
      margin={{ top: 70, right: 20, bottom: 20, left: 20 }}
      padding={0.65}
      innerPadding={2}
      layout="horizontal"
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={[
        "var(--diffrent-chart-first-color)",
        "var(--diffrent-chart-second-color)",
        "var(--diffrent-chart-third-color)",
      ]}
      borderRadius={7}
      borderColor={{
        from: "color",
        modifiers: [["darker", "1.5"]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={null}
      enableGridY={false}
      enableLabel={false}
      labelSkipWidth={12}
      labelSkipHeight={10}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      legends={[]}
      isInteractive={false}
      role="application"
      isFocusable={true}
      barAriaLabel={(e) => e.id + ": " + e.formattedValue + " in country: " + e.indexValue}
    />
  );
};

export default DiffrentChart;
